export const homeView = {
  methods: {
    //TODO: 获取租户信息
    async getTenantInfo() {
      let res = await this.$http.get(`/tenant/safeTenant/getSafeTenantDetail`);
      return res.data;
    },
    //TODO： 获取安全履职情况
    async getlzInfit() {
      let res = await this.$http.get(`/tenant/home/duty/situation`);
      return res;
    },

    //TODO: 获取重点关注
    async getDangersAndDangers() {
      let res = await this.$http.get(`/tenant/home/dangersAndDangers`);
      return res;
    },

    //TODO: 获取政策法规变化
    async getPolicyChange() {
      let res = await this.$http.get(`/tenant/policy/homeList`);
      return res.rows;
    },
    //TODO: 近期事故案例
    async getRecentAccident() {
      let res = await this.$http.get(`/tenant/cases/homeList`);
      return res.rows;
    }
  },
};
